module.exports = __webpack_public_path__ + "img/hktcmbanner.f0ed676a.jpg";